module.exports = __webpack_public_path__ + "assets/43e9f83f39f5e78f8ebd9444ac7c6c6b.png";